import { createSlice } from "@reduxjs/toolkit";
import { ICONS } from "../constants/Icons";

export const designerPropertiesSlice = createSlice({
  name: "properties",
  initialState: {
    categories: [],
    channels: [],
    rowSeatSpacing: 2,
    rowSpacing: 2,
    rowSeatSize: 15,
    spinning: false,
    selectedSeats: [],
    selection: [],
    available: false,
    open: false,
    zoneActive: false,
    selectedChannel: {
      name: '',
      color: '',
      key: ''
    },
    channelList: [],
    showZoomWatermark: false,
    svgIcon: ICONS[0],
    svgFill: "#000000",
    svgScale: 1,
    roundTableSeats: 6,
    roundTableRadius: 20,
    rectTableSeats: {
      up: 4,
      down: 4,
      left: 0,
      right: 0
    },
    rectTableDimensions: {
      width: 75,
      height: 50
    }
  },
  reducers: {
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setChannels: (state, action) => {
      if (Array.isArray(action.payload)) state.channels = action.payload;
      else {
        state.channels = [];
        window.redseats.channels = [];
      }
    },
    setSeatSpacing: (state, action) => {
      state.rowSeatSpacing = action.payload;
    },
    setRowSpacing: (state, action) => {
      state.rowSpacing = action.payload;
    },
    setRowSeatSize: (state, action) => {
      state.rowSeatSize = action.payload;
    },
    setSpinning: (state, action) => {
      state.spinning = action.payload;
    },
    setSelection: (state, action) => {
      state.selection = action.payload;
    },
    addSeatToSelection: (state, action) => {
      const {
        payload: { index, seat },
      } = action;
      const { selection } = state;
      selection[index].seats.push(seat);
    },
    removeSeatToSelection: (state, action) => {
      const {
        payload: { index, seat: actionSeat },
      } = action;
      let { selection } = state;
      selection[index].seats = selection[index].seats.filter(
        (seat) => seat !== actionSeat
      );
    },
    setSelectedSeats: (state, action) => {
      state.selectedSeats = action.payload;
    },
    addSelectedSeat: (state, action) => {
      state.selectedSeats.push(action.payload);
    },
    removeSelectSeat: (state, action) => {
      state.selectedSeats = state.selectedSeats.filter(
        (seat) => seat != action.payload
      );
    },
    setAvailableToPublish: (state, action) => {
      state.available = action.payload;
    },
    openModal: (state, action) => {
      state.open = action.payload;
    },
    setZoneActive: (state, action) => {
      state.zoneActive = action.payload
    },
    setSelectedChannel: (state, action) => {
      state.selectedChannel = action.payload
    },
    setChannelList: (state, action) => {
      state.channelList = action.payload
    },
    setShowZoomWatermark: (state, action) => {
      state.showZoomWatermark = action.payload
    },
    setSvgIcon: (state, action) => {
      state.svgIcon = action.payload
    },
    setSvgFill: (state, action) => {
      state.svgFill = action.payload
    },
    setSvgScale: (state, action) => {
      state.svgScale = action.payload
    },
    setRoundTableSeats: (state, action) => {
      state.roundTableSeats = action.payload
    },
    setRoundTableRadius: (state, action) => {
      state.roundTableRadius = action.payload
    },
    setRectTableSeats: (state, action) => {
      const { key, value } = action.payload;
      state.rectTableSeats[key] = value;
    },
    setRectTableDimensions: (state, action) => {
      const { key, value } = action.payload;
      state.rectTableDimensions[key] = value;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setCategories,
  setChannels,
  setSeatSpacing,
  setRowSpacing,
  setRowSeatSize,
  setSpinning,
  setSelectedSeats,
  addSelectedSeat,
  removeSelectSeat,
  setSelection,
  addSeatToSelection,
  removeSeatToSelection,
  setAvailableToPublish,
  openModal,
  setZoneActive,
  setSelectedChannel,
  setChannelList,
  setShowZoomWatermark,
  setSvgIcon,
  setSvgFill,
  setSvgScale,
  setRoundTableSeats,
  setRoundTableRadius,
  setRectTableSeats,
  setRectTableDimensions
} = designerPropertiesSlice.actions;

export default designerPropertiesSlice.reducer;
